import React, { useEffect, useState } from "react";
import "../../Assets/Styles/pages/landing.scss";
import WaterMarkFeature from "../../Components/LandingComponents/WaterMarkFeature";
import AddWaterMark from "../../Components/LandingComponents/addWaterMark";
import Banner from "../../Components/LandingComponents/banner";
import MobileIntro from "../../Components/LandingComponents/mobileIntro";
import Reviews from "../../Components/LandingComponents/reviews";
import Blogs from "../Blogs/blogs";

const Landing = () => {
  const [loaded, setLoaded] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Banner loaded={loaded} setLoaded={setLoaded} />
      {loaded.length >= 1 && (
        <>
          <MobileIntro loaded={loaded} setLoaded={setLoaded} />
          <WaterMarkFeature view={true} loaded={loaded} setLoaded={setLoaded} />
          <AddWaterMark loaded={loaded} setLoaded={setLoaded} />
          <Reviews loaded={loaded} setLoaded={setLoaded} />
          <Blogs limit={2} />
        </>
      )}
    </>
  );
};

export default Landing;
